// Step key -> component. The server owns which steps exist for a product type
// (Shop::WizardSteps); this only says how to draw one. 'contents' merges what were
// two steps -- see Contents.jsx for why the print-package question went away, and
// 'schools' absorbed what was the 'pricing' step -- see Schools.jsx.
import Basics from './Basics';
import Contents from './Contents';
import Presentation from './Presentation';
import Upsell from './Upsell';
import Schools from './Schools';
import Offers from './Offers';
import Review from './Review';

export default {
  basics: Basics,
  contents: Contents,
  presentation: Presentation,
  upsell: Upsell,
  schools: Schools,
  offers: Offers,
  review: Review,
};
